import { render, staticRenderFns } from "./OpenView.vue?vue&type=template&id=7cb0c7f8&scoped=true&"
import script from "./OpenView.vue?vue&type=script&lang=js&"
export * from "./OpenView.vue?vue&type=script&lang=js&"
import style0 from "./OpenView.vue?vue&type=style&index=0&id=7cb0c7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0c7f8",
  null
  
)

export default component.exports